import type { Severity, SpeedEventType, UUID } from '@cobliteam/common-types';

import type { LatLng } from '../geocode';

export enum SeverityAPI {
  MEDIUM = 'medium',
  HIGH = 'high',
  HIGHER = 'higher',
}

export interface SpeedEventAPI {
  event_time: number;
  vehicle_id: UUID;
  group_id?: UUID;
  device_id: string;
  driver_id?: UUID;
  location: LatLng;
  speed_in_kmh: number;
  speed_limit_in_kmh: number;
  duration_above_in_millis?: number;
  severity: SeverityAPI;
  start_time?: number;
  median_speed_in_kmh?: number;
  median_based_severity?: SeverityAPI;
}

export interface AggregatedSpeedEvent {
  mediumEvents: number;
  highEvents: number;
  higherEvents: number;
  totalEvents: number;
}

export interface HomeSpeed {
  roadEvents: AggregatedSpeedEvent;
  vehicleEvents: AggregatedSpeedEvent;
}

export enum DashCamFilter {
  ALL = 'ALL',
  ONLY_CAMERAS = 'ONLY_CAMERAS',
  ONLY_NOT_CAMERAS = 'ONLY_NOT_CAMERAS',
}

export enum ReportFormat {
  EXCEL = 'EXCEL',
  CSV = 'CSV',
}

export enum ReportAggregatedBy {
  VEHICLE = 'VEHICLE',
  DRIVER = 'DRIVER',
  VEHICLE_GROUP = 'VEHICLE_GROUP',
}

export interface BaseRequest {
  startDate: number;
  endDate: number;
}

export interface SpeedingRequest extends BaseRequest {
  eventType: SpeedEventType;
  wantedIds?: UUID[];
  wantedGroupIds?: UUID[];
  wantedSeverities?: Severity[];
  dashCamFilter?: DashCamFilter;
  useMedianBasedMetrics: Boolean;
}

export interface SpeedingReportRequest extends SpeedingRequest {
  destinationEmails: string[];
  reportFormat: ReportFormat;
}

export enum ChartAggregation {
  FLEET_BY_VEHICLE = 'FLEET_BY_VEHICLE',
  FLEET_BY_DRIVER = 'FLEET_BY_DRIVER',
  VEHICLE = 'VEHICLE',
  DRIVER = 'DRIVER',
  VEHICLE_GROUP = 'VEHICLE_GROUP',
}

export enum ChartType {
  EVENTS_COUNT = 'EVENTS_COUNT',
  PERCENTAGE_ABOVE_LIMIT = 'PERCENTAGE_ABOVE_LIMIT',
}

export interface SpeedingChartRequest extends BaseRequest {
  subdomain: SpeedEventType;
  type: ChartType;
  aggregationField: ChartAggregation;
  wantedIds?: UUID[];
  wantedSeverities?: Severity[];
  dashCamFilter?: DashCamFilter;
  useMedianBasedMetrics: Boolean;
}

export interface TimeseriesChartData {
  aggregationDate: string;
  value: number;
  metricName: string;
}

export interface TimeseriesChart {
  id: string;
  label?: string;
  data: TimeseriesChartData[];
}

export interface HeatmapChart {
  value: number;
  trimmedLatitude: number;
  trimmedLongitude: number;
}
